import { createContext } from "react";
import { BaseReportEntity } from "../../models/base";
import { Page } from "./page";

const PageConfigurationContext = createContext<Page<BaseReportEntity>>({} as Page<BaseReportEntity>);

export default PageConfigurationContext;
